import { useApi } from "../../api/hooks/use-api.ts";
import { ApiMethod } from "../../api/types.ts";
import { withObjectPayload } from "../../api/payload.ts";

export const useContentApi = () => {
    const { sendProtectedRequest } = useApi();

    // OK: payload is { content: <markdown> }. Error: payload is the error object.
    const getContent = async (title: string) => {
        const response = sendProtectedRequest(
            ApiMethod.GET,
            process.env.REACT_APP_FPSB_PORTAL_REQUEST_ENDPOINT +
            '&token=' + process.env.REACT_APP_FPSB_PORTAL_TOKEN +
            '&action=content&title=' + encodeURIComponent(title)
        );

        return response.then(withObjectPayload);
    };

    return { getContent };
};
